import { BaseTargeting, BaseTargetingInput, normalizeTargeting } from './featureTargeting'

export type FlagKind = 'boolean' | 'string' | 'number' | 'json' | 'enum'

export type FlagDef<TValue> = {
  __type?: TValue
  kind: FlagKind
  targeting: BaseTargeting
  values?: readonly string[]
}

export type BooleanFlagDef = FlagDef<boolean> & { kind: 'boolean' }
export type StringFlagDef = FlagDef<string> & { kind: 'string' }
export type NumberFlagDef = FlagDef<number> & { kind: 'number' }
export type JsonFlagDef<TValue> = FlagDef<TValue> & { kind: 'json' }
export type EnumFlagDef<TValues extends readonly string[]> = FlagDef<TValues[number]> & {
  kind: 'enum'
  values: TValues
}

export type FlagValueForDef<TDef> = TDef extends FlagDef<infer TValue> ? TValue : never

export type FlagsFromManifest<TManifest extends Record<string, FlagDef<unknown>>> = {
  [K in keyof TManifest]: FlagValueForDef<TManifest[K]>
}

export const flag = {
  boolean: (targeting?: BaseTargetingInput): BooleanFlagDef => ({
    kind: 'boolean',
    targeting: normalizeTargeting(targeting),
  }),
  enum: <const TValues extends readonly string[]>(
    values: TValues,
    targeting?: BaseTargetingInput
  ): EnumFlagDef<TValues> => ({
    kind: 'enum',
    targeting: normalizeTargeting(targeting),
    values,
  }),
  json: <TValue>(targeting?: BaseTargetingInput): JsonFlagDef<TValue> => ({
    kind: 'json',
    targeting: normalizeTargeting(targeting),
  }),
  number: (targeting?: BaseTargetingInput): NumberFlagDef => ({
    kind: 'number',
    targeting: normalizeTargeting(targeting),
  }),
  string: (targeting?: BaseTargetingInput): StringFlagDef => ({
    kind: 'string',
    targeting: normalizeTargeting(targeting),
  }),
} as const

export const defineFlagsManifest = <TManifest extends Record<string, FlagDef<unknown>>>(manifest: TManifest) => manifest
